/** @jsxImportSource @emotion/react */

import { Modal } from "antd";
import { LIST_NEWS } from "constants/list-news";
import { ModalTypeValue } from "enums/modalType";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import { useEffect } from "react";
import { selectOpenModal, setOpenModal } from "store/master";

import { ModalNewsStyle } from "./style.index";

const ModalNews = () => {
  const openModal = useAppSelector(selectOpenModal);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const handleEsc = (event: any) => {
      if (event.keyCode === 27) {
        dispatch(setOpenModal(ModalTypeValue.CLOSE));
      }
    };

    window.addEventListener("keydown", handleEsc);

    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, []);
  return (
    <Modal
      open={openModal === ModalTypeValue.NEWS}
      onCancel={() => dispatch(setOpenModal(ModalTypeValue.CLOSE))}
      css={ModalNewsStyle.wrapper}
      title="Tin tức mới nhất"
      closable={false}
      footer={
        <button
          onClick={() => {
            dispatch(setOpenModal(ModalTypeValue.CLOSE));
          }}
        >
          Đóng
        </button>
      }
    >
      <div css={ModalNewsStyle.mainContent}>
        <ul>
          {LIST_NEWS.map((items, index) => (
            <li key={index}>{items.content}</li>
          ))}
        </ul>
      </div>
    </Modal>
  );
};

export default ModalNews;
